import React, { ReactElement } from 'react';
import { makeStyles } from '@material-ui/core';
import { displayAsPrice } from './helpers';
import { TransactionRule } from './types';

const useStyles = makeStyles(theme => ({
  container: {
    margin: `${theme.spacing(2)}px 0`,
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    color: theme.palette.warning.main,
    backgroundColor: theme.palette.warning.light,
  },
  price: {
    fontWeight: 800,
    fontSize: '18px',
  },
  name: {
    fontSize: '20px',
    fontWeight: 400,
  },
}));

const TransactionRuleDisplay = ({ name, amount }: TransactionRule): ReactElement => {
  const classes = useStyles();

  return (
    <div aria-label="transaction-rule" className={classes.container}>
      <div className={classes.name}>{name}</div>
      <div className={classes.price}>{displayAsPrice(amount)}</div>
    </div>
  );
};

export default TransactionRuleDisplay;
